<div class="version-selector" (click)="stopPropagation($event)">
  <div class="selector-label">Version:</div>
  <div class="selector-dropdown" [class.open]="isOpen">
    <div class="selected-version" (click)="toggleDropdown()" role="button" tabindex="0" 
         [attr.aria-expanded]="isOpen" [attr.aria-label]="'Select API version, current: ' + selectedVersion?.version">
      <span class="version-text">
        {{ selectedVersion?.version }}
        <span class="default-badge" *ngIf="selectedVersion?.isDefault" title="Latest version">★</span>
      </span>
      <svg class="dropdown-icon" [class.rotated]="isOpen" 
           width="16" height="16" viewBox="0 0 16 16" fill="none" 
           xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6L8 10L12 6" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
      </svg>
    </div>
    
    <div class="dropdown-menu" *ngIf="isOpen" role="menu">
      <div class="dropdown-item" 
           *ngFor="let version of versions"
           (click)="selectVersion(version)"
           [class.selected]="version.apiId === selectedVersionId"
           [class.default]="version.isDefault"
           role="menuitem"
           tabindex="0"
           [attr.aria-label]="getVersionLabel(version)">
        <div class="version-info-item">
          <span class="version-name">{{ version.version }}</span>
          <span class="default-indicator" *ngIf="version.isDefault">★ Default</span>
        </div>
      </div>
    </div>
  </div>
</div>
